export default __webpack_public_path__ + "static/media/leitor-cod-barras.4d08063d.png";